import {Component, Input} from "@angular/core";
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PromocionInfo} from "../../../core/promociones/promocion-info";
import {PromocionesService} from "../../../core/promociones/promociones.service";

@Component(
  {
    selector: 'ngbd-modal-content',
    template: `
      <div class="modal-header">
        <h4 class="modal-title">Promociones</h4>
        <button type="button" class="close" aria-label="Close" [disabled]="loading" (click)="activeModal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        ¿ Está seguro que quiere
        <span class="font-weight-bold">{{promocion.active ? 'DESACTIVAR' : 'ACTIVAR'}}</span> la promoción:
        <br><span class="font-weight-bold">{{promocion.name}}</span> ?
      </div>
      <div class="modal-footer">
        <div>
          <button type="button" class="btn btn-danger" [disabled]="loading" (click)="activeModal.close('Close click')">Cancelar</button>
          <button type="button" class="btn btn-primary ml-2" [ladda]="loading" (click)="disablePromotion()">Aceptar</button>
        </div>
      </div>
    `
  }
)
export class ActivationModalComponent {
  @Input() promocion: PromocionInfo;
  loading = false;

  constructor(public activeModal: NgbActiveModal, private promocionesService: PromocionesService) {
  }

  disablePromotion() {
    this.loading = true;
    this.promocionesService.disablePromotion(this.promocion).subscribe(() => {
      this.promocion.active = !this.promocion.active;
      this.activeModal.close();
    }, () => {
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/quantum/activation-modal-component.ts